import { render, staticRenderFns } from "./ArchivedListingsList.vue?vue&type=template&id=2def6611&scoped=true"
import script from "./ArchivedListingsList.vue?vue&type=script&lang=js"
export * from "./ArchivedListingsList.vue?vue&type=script&lang=js"
import style0 from "./ArchivedListingsList.vue?vue&type=style&index=0&id=2def6611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def6611",
  null
  
)

export default component.exports